export const SECONDS_IN_A_DAY = 86400 // 24 * 60 * 60
export const MINUTES_IN_A_DAY = 1440 // 24 * 60
export const SLOT_HEIGHT_PX = 40 // Slot height in pixels
export const MINUTES_IN_HOUR = 60
export const MIN_DURATION_SECONDS = 15 * 60
export const MAX_DURATION_SECONDS = 24 * 60 * 60 // 24 hours in seconds

export const SNAP_INCREMENT_MINUTES = 15 // 15-minute increments
export const MIN_DURATION_MINUTES = 15 // Minimum duration of 15 minutes
export const DEFAULT_DURATION_MINUTES = 60 // Default duration of 60 minutes

// Time-to-pixel ratio
export const PIXELS_PER_MINUTE = SLOT_HEIGHT_PX / MINUTES_IN_HOUR
